"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CreateAndAssociate = void 0;

var React = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _reactHotLoader = require("react-hot-loader");

var _blocks = require("@bueno/blocks");

var Elements = _interopRequireWildcard(require("../ActionModal.styles"));

var _ActionDetails = require("../components/ActionDetails");

var _CreateAndAssociateForm = require("./components/CreateAndAssociateForm");

var _actionCreators = require("../../../redux/modules/action/actionCreators");

var _hooks = require("../../../utils/hooks");

var _LoadingOverlay = require("../components/LoadingOverlay");

var _useAxiosSwr = require("../../../utils/useAxiosSwr");

function mapStateToProps({
  betaAction,
  auth
}) {
  var _auth$user$portfolio$, _auth$user$portfolio;

  return {
    isPending: betaAction.isPending,
    organisations: Object.values((_auth$user$portfolio$ = (_auth$user$portfolio = auth.user.portfolio) === null || _auth$user$portfolio === void 0 ? void 0 : _auth$user$portfolio.projects) !== null && _auth$user$portfolio$ !== void 0 ? _auth$user$portfolio$ : {}),
    userId: auth.user.forgeId
  };
}

const mapDispatchToProps = {
  requestSave: _actionCreators.addAction
};

const CreateAndAssociate = ({
  isOpen,
  onRequestClose,
  hits,
  requestSave,
  isPending,
  userId,
  organisations
}) => {
  const [validForm, setValidForm] = React.useState(false);
  const [pristine, setPristine] = React.useState(true);
  const localHits = React.useRef(hits); // * Cache local hits as props will change during form submission

  const formRef = React.useRef(null);
  const wasPending = (0, _hooks.usePrevious)(isPending);
  const {
    ruleName,
    site,
    ruleCategory = ''
  } = localHits.current[0];
  const {
    label
  } = site;
  const targetNames = localHits.current.map(h => h.targetName);

  const handleCreateAction = () => {
    const createActionForm = formRef.current;

    if (createActionForm !== null) {
      createActionForm.dispatchEvent(new Event('submit', {
        cancelable: true,
        bubbles: true
      }));
    }
  };
  /**
   * If form has been changed, confirm before discarding changes.
   */


  const handleClose = React.useCallback(function handleClose() {
    let shouldClose = true;

    if (!pristine) {
      shouldClose = window.confirm('You have unsaved changes that will be lost.');
    }

    if (shouldClose) {
      onRequestClose();
    }
  }, [pristine]); // Handle finding the assignee and site IDs before submitting

  const [projectKey, siteLabel] = site.id.split('~');
  const {
    data: assigneeData = []
  } = (0, _useAxiosSwr.useHashtagUsernameList)(projectKey, siteLabel, {
    skip: wasPending
  });

  const onSubmit = values => {
    var _assigneeData$find$au, _assigneeData$find, _organisations$find;

    const equipList = localHits.current.map(h => h.equipRuleId);
    values.site = site.id;
    const payload = { // Support hydra action creation
      ...values,
      siteId: site.forgeId,
      assigneeId: (_assigneeData$find$au = assigneeData === null || assigneeData === void 0 ? void 0 : (_assigneeData$find = assigneeData.find(assignee => assignee.display === values.assignee)) === null || _assigneeData$find === void 0 ? void 0 : _assigneeData$find.authId) !== null && _assigneeData$find$au !== void 0 ? _assigneeData$find$au : null,
      // Support attachments, these are stripped in serialiseCreateAction
      userId,
      attachment: values.screenshot,
      organisationId: (_organisations$find = organisations.find(organisation => site.projectId === organisation.project_pk)) === null || _organisations$find === void 0 ? void 0 : _organisations$find.forge_id
    };
    if (validForm) requestSave(payload, equipList);
  };

  React.useEffect(() => {
    if (wasPending && !isPending) {
      onRequestClose();
    }
  }, [isPending]);
  return /*#__PURE__*/React.createElement(Elements.Modal, {
    title: /*#__PURE__*/React.createElement(Elements.Title, null, "New Action"),
    isOpen: isOpen,
    onRequestClose: handleClose
  }, /*#__PURE__*/React.createElement(Elements.ModalContent, {
    isPending: isPending
  }, isPending && /*#__PURE__*/React.createElement(_LoadingOverlay.LoadingOverlay, null), /*#__PURE__*/React.createElement(Elements.DoubleColumnLayout, null, /*#__PURE__*/React.createElement(Elements.LeftCol, null, /*#__PURE__*/React.createElement(_ActionDetails.ActionDetail, {
    label: label,
    description: ruleName,
    targetNames: targetNames
  })), /*#__PURE__*/React.createElement(Elements.RightCol, null, /*#__PURE__*/React.createElement(_CreateAndAssociateForm.CreateAndAssociateForm, {
    formRef: formRef,
    onSubmit: onSubmit,
    setValidForm: setValidForm,
    setPristine: setPristine,
    site: site,
    assignees: assigneeData,
    defaultSummary: ruleName,
    defaultContext: ruleCategory
  })))), /*#__PURE__*/React.createElement(_blocks.ModalFooter, null, /*#__PURE__*/React.createElement(_blocks.ControlGroup, {
    tight: true
  }, /*#__PURE__*/React.createElement(_blocks.Button, {
    appearance: "plain",
    onClick: handleClose
  }, "Cancel"), /*#__PURE__*/React.createElement(_blocks.Button, {
    appearance: "solid",
    primary: true,
    onClick: handleCreateAction,
    disabled: isPending,
    className: "AddAction--Submit"
  }, "Add Action"))));
};

const connected = (0, _reactHotLoader.hot)(module)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CreateAndAssociate));
exports.CreateAndAssociate = connected;